import useDate from "~/ui-rtk/hooks/date"

const dayjs = useDate()

/** True when the whole selected period falls after the latest analyzed mention. */
export function isPeriodAfterLatestAnalyzedDate(
  dateRange: [Date, Date],
  latestDate?: Date,
): boolean {
  if (!latestDate) {
    return false
  }
  return dayjs(dateRange[0])
    .startOf("day")
    .isAfter(dayjs(latestDate).startOf("day"))
}
